import CryptoJS from "crypto-js";

export const generateAuthHeader = (login: string, password: string): string => {
  const hashedPassword = CryptoJS.SHA512(password).toString();
  const loginPasswordString = `${login}:${hashedPassword}`;
  const loginPswdBase64 = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(loginPasswordString),
  );
  return `Basic ${loginPswdBase64}`;
};

export const LOCAL_STORAGE_KEY = "persist:web-orders";

export const getToken = (key: string): string | null => {
  const persistedData = localStorage.getItem(key);

  if (!persistedData) {
    return null;
  }

  try {
    const parsedData = JSON.parse(persistedData);

    if (parsedData.auth) {
      const authData = JSON.parse(parsedData.auth);

      return authData.token.AccessToken || null;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};
